import axios from 'axios';

export const baseApiUrl = `${process.env.VUE_APP_API}/sessions`;


export const CallService = {
  generateRequestHeaders(accountToken) {
    return {
      Authorization: `Access ${accountToken}`,
    };
  },

  getSessionsActive(token) {
    return axios.get(
      `${baseApiUrl}/accountactive`,
      {
        headers: this.generateRequestHeaders(token)
      }
    )
  }
}